<!-- 过夜袋航班详情（移动运行网扫码） -->
<template>
  <div class="backgroundGrey">
    <template v-if="lists.length">
      <div class="details-card" v-for="(item,index) in lists" :key="index">
        <div class="detailsItem" @click="openDetails(item)">
          <div>
            <span>航班日期：</span>
            <span>{{ item.flightDateDesc }}</span>
          </div>
          <div>
            <span>航班环：</span>
            <span>{{ item.flightNoRing }}</span>
          </div>
          <div>
            <span>航段环：</span>
            <span>{{ item.flightLineRing }}</span>
          </div>
          <div>
            <span>状态：</span>
            <span>{{ item.stateDesc }}</span>
          </div>
        </div>
      </div>
    </template>
    <EmptyTips :tipsList="['暂无记录']" v-else />
  </div>
</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'

export default {
  components: {
    EmptyTips,
  },
  data() {
    return {
      lists: [],
    }
  },
  activated() {
    this.$EventBus.$emit('setTitle', '航班信息')
    this.$EventBus.$emit('setPageName', 'OvernightBag')
    this.$EventBus.$emit('setShowHome', false)
    this.getOveninght()
  },
  created() {
  },
  methods: {
    openDetails(item) {
      if (item.sellType == 0) {
        this.$utils.routerPush({
          name: 'OvernightBagDetails',
          query: {
            id: item.id,
          },
        })
      }
      if (item.sellType == 1) {
        this.$utils.routerPush({
          name: 'OvernightCarDetails',
          query: {
            id: item.id,
          },
        })
      }
    },
    // 获取过夜袋详情
    getOveninght() {
      let _this = this
      let params = {
        pageSize: 10000,
        pageIndex: 1,
        searchData: {
          // staffId: 1000134488,
          staffId: this.$store.state.userInfo.userId,
          state: -1, // -1全部即（3.已领取 4.已归还 5.已完成
        },
      }
      this.$api.post('/api-sys/apiStaffOverNightBag/getHandlerListByPage', params).then((res) => {
        if (res.code === '0000') {
          _this.lists = res.data.list
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/view/OvernightBag/OvernightBag.vue